import { ReactElement } from 'react'

import { Select } from 'antd'
import { Field } from 'formik'

import { FormikSelect } from 'components/formik'
import { Campaign } from 'types'

import { useFetchAdGroupsCached } from './localHooks'

interface Props {
    name: string
    campaign: Campaign
}

const AdGroupSelectFormikField = ({ name, campaign }: Props): ReactElement => {
    const [isFetching, options] = useFetchAdGroupsCached(campaign, name, true)

    return (
        <Field
            name={name}
            component={FormikSelect}
            placeholder="Select Target Ad Group"
            loading={isFetching}
            disabled={isFetching}
            style={{ width: '100%', maxWidth: 200 }}
        >
            {options.map(({ value, label }) => (
                <Select.Option key={value} value={value}>
                    {label}
                </Select.Option>
            ))}
        </Field>
    )
}

export default AdGroupSelectFormikField
